(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapa-comunas-envio"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TRUCK = '<svg class="mce__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h10v8h-10z"/><path d="M12.5 9h3.5l3 3v2.5h-6.5z"/><circle cx="6" cy="17" r="1.7"/><circle cx="16.5" cy="17" r="1.7"/></svg>';
  function initAll() {
    document.querySelectorAll('.mce').forEach(function (root) {
      if (root.dataset.mceInit) return;
      root.dataset.mceInit = '1';
      init(root);
    });
  }
  function init(root) {
    var svg = root.querySelector('.mce__svg');
    var tooltip = root.querySelector('.mce__tooltip');
    var mapwrap = root.querySelector('.mce__mapwrap');
    var sched = root.querySelector('.mce__schedule');
    var hint = sched ? (sched.getAttribute('data-hint') || '') : '';
    var sectorsData = {};
    try { sectorsData = JSON.parse(root.querySelector('[data-mce-sectors]').textContent); } catch (e) {}
    var active = new Set();
    var paths = Array.prototype.slice.call(root.querySelectorAll('.cm, .cm-pin'));
    var labels = Array.prototype.slice.call(root.querySelectorAll('.cm-lbl'));

    function esc(t){ var d=document.createElement('div'); d.textContent=t==null?'':t; return d.innerHTML; }

    function renderSchedule() {
      if (!sched) return;
      if (active.size === 1) {
        var sec = active.values().next().value;
        var info = sectorsData[sec] || {};
        var color = getComputedStyle(root).getPropertyValue('--mce-s' + sec).trim();
        sched.style.setProperty('--c', color);
        sched.classList.add('is-active');
        sched.innerHTML = '<span class="mce__sched-dot"></span>'
          + '<span class="mce__sched-name">' + esc(info.name || ('Sector ' + sec)) + '</span>'
          + '<span class="mce__sched-days">' + TRUCK + '<span>' + esc(info.dias || '') + '</span></span>';
      } else {
        sched.classList.remove('is-active');
        sched.style.removeProperty('--c');
        sched.innerHTML = '<span class="mce__sched-hint">' + esc(hint) + '</span>';
      }
    }

    function render() {
      var filtering = active.size > 0;
      svg.classList.toggle('is-filtering', filtering);
      paths.forEach(function (el) { el.classList.toggle('is-on', active.has(el.getAttribute('data-sector'))); });
      labels.forEach(function (el) {
        var name = el.getAttribute('data-for');
        var match = paths.filter(function (p) { return p.getAttribute('data-comuna') === name; })[0];
        el.classList.toggle('is-on', !!(match && active.has(match.getAttribute('data-sector'))));
      });
      root.querySelectorAll('.mce__chip').forEach(function (chip) {
        var sec = chip.dataset.sector;
        var on = sec === 'all' ? active.size === 0 : active.has(sec);
        chip.classList.toggle('is-active', on); chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      renderSchedule();
    }

    root.querySelectorAll('.mce__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var sec = chip.dataset.sector;
        if (sec === 'all') active.clear();
        else if (active.has(sec)) active.clear();
        else { active.clear(); active.add(sec); }
        render();
      });
    });

    function showTip(el, x, y) {
      var name = el.getAttribute('data-comuna'); if (!name) return;
      var s = el.getAttribute('data-sector');
      var dias = (sectorsData[s] && sectorsData[s].dias) || '';
      tooltip.innerHTML = '<b>' + esc(name) + '</b>' + (dias ? ('Despacho: ' + esc(dias)) : 'Sin cobertura por ahora');
      tooltip.hidden = false;
      var r = mapwrap.getBoundingClientRect();
      tooltip.style.left = (x - r.left) + 'px'; tooltip.style.top = (y - r.top) + 'px';
    }
    function hideTip() { tooltip.hidden = true; }
    paths.forEach(function (el) {
      el.addEventListener('mousemove', function (e) { showTip(el, e.clientX, e.clientY); });
      el.addEventListener('mouseleave', hideTip);
      el.addEventListener('focus', function () { var b = el.getBoundingClientRect(); showTip(el, b.left + b.width / 2, b.top + b.height / 2); });
      el.addEventListener('blur', hideTip);
      el.addEventListener('click', function () {
        var s = el.getAttribute('data-sector'); if (!s || s === '0') return;
        active.clear(); active.add(s); render();
        var b = el.getBoundingClientRect(); showTip(el, b.left + b.width / 2, b.top); setTimeout(hideTip, 1800);
      });
    });

    render();
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
